import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
import index from "../pages/index.vue";
import icibe from "../pages/icibe.vue"
import temp from "../pages/temp.vue";
import rportapplication from "../pages/RecruitmentPortApplication.vue";
import companyqualification from "../pages/CompanyQualification.vue";
// import companyqualification from "../pages/CompanyQualificationTemp.vue";
import declarationOfInterests from "../pages/DeclarationOfInterests.vue";
import portFeeApplication from "../pages/PortFeeApplication.vue";
import personnelRequirements from "../pages/PersonnelRequirements.vue";
import personnelCostApplication from "../pages/PersonnelCostApplication.vue";
import nonBusinessSeal from "../pages/NonBusinessSeal.vue";
import overTimeApply from "../pages/OverTimeApply.vue";
import newComerAdvanced from "../pages/NewComerAdvanced.vue";
import YSXMBYXWJHMTSHZSQ from "../pages/YSXMBYXWJHMTSHZSQ.vue";
import ZBJZFSQB from "../pages/ZBJZFSQB.vue";
import KPZLHTJGPZZHTGZSQ from "../pages/KPZLHTJGPZZHTGZSQ.vue";
import phoneShort from "../pages/PhoneShort.vue";
import projectLinkage from "../pages/ProjectLinkage.vue";
import suspensionCommission from "../pages/SuspensionCommission.vue";
import projectHousing from "../pages/ProjectHousing.vue";
import newBranchInvoice from "../pages/NewBranchInvoice.vue";
import borrowing from "../pages/Borrowing.vue";
import commissionAuthorization from "../pages/CommissionAuthorization.vue";
import commissionAuthorizationSpecial from "../pages/CommissionAuthorizationSpecial.vue";
import beOnABusinessTrip from "../pages/BeOnABusinessTrip.vue";
import YGRSLGZSPSQ from "../pages/YGRSLGZSPSQ.vue";
import RSLTSSQ from "../pages/RSLTSSQ.vue";
import TJSQB from "../pages/TJSQB.vue";
import otherApplySignApprove from "../pages/OtherApplySignApprove.vue";
import projectCommissionRecovery from "../pages/ProjectCommissionRecovery.vue";
import projectCommissionConfirm from "../pages/ProjectCommissionConfirm.vue";
import cancelEntrustedHousing from "../pages/CancelEntrustedHousing.vue";
import applyFee from "../pages/ApplyFee.vue";
import contractRiskWarning from "../pages/ContractRiskWarning.vue";
import specialTransaction from "../pages/SpecialTransaction.vue";
import housingCircle from "../pages/HousingCircle.vue";
import cooperationInfoFee from "../pages/CooperationInfoFee.vue";
import XQSQ from "../pages/XQSQ.vue";
import FHHCFP from "../pages/FHHCFP.vue";
import ITAssetMaintenance from "../pages/ITAssetMaintenance.vue";
import ITEquipmentAllocation from "../pages/ITEquipmentAllocation.vue";
import ITNotSssetsSuspense from "../pages/ITNotSssetsSuspense.vue";
import AdministrativeProcurementA from "../pages/AdministrativeProcurementA.vue";
import rentBorrowing from "../pages/RentBorrowing.vue";
import salaryManager from "../pages/SalaryManager.vue";
import firstHandProject from "../pages/FirstHandProject.vue";
import projectBudget from "../pages/ProjectBudget.vue";
import projectBudgetPricing from "../pages/ProjectBudgetPricing.vue";
import projectSettlement from "../pages/ProjectSettlement.vue";
import projectSettlementPricing from "../pages/ProjectSettlementPricing.vue";
import projectCostApplication from "../pages/ProjectCostApplication.vue";
import projectCostPricing from "../pages/ProjectCostPricing.vue";
import projectCostCheck from "../pages/ProjectCostCheck.vue";
import AdministrativeProcurementB from "../pages/AdministrativeProcurementB.vue";
import AdministrativeProcurementInconformity from "../pages/AdministrativeProcurementInconformity.vue";
import ITEquipmentScrapping from "../pages/ITEquipmentScrapping.vue";
import administrativeProcurementApplication from "../pages/AdministrativeProcurementApplication.vue";
import administrativeProcurementPricing from "../pages/AdministrativeProcurementPricing.vue";
import administrativeProcurementCheck from "../pages/AdministrativeProcurementCheck.vue";
import ITNotAssetAllocation from "../pages/ITNotAssetAllocation.vue";
import iTNotAssetsScrap from "../pages/ITNotAssetsScrap.vue";
import ITAssetMaintenanceA from "../pages/ITAssetMaintenanceA.vue";
import DHYWLYWSQ from "../pages/DHYWLYWSQ.vue";
import YKFPYQHMLQPSQ from "../pages/YKFPYQHMLQPSQ.vue";
import GRZHQXKTHBGSQB from "../pages/GRZHQXKTHBGSQB.vue";
import MPSQ from "../pages/MPSQ.vue";
import ITSBCGSQ from "../pages/ITSBCGSQ.vue";
import ITSBCGYS from "../pages/ITSBCGYS.vue";
import KGPSQP from "../pages/KGPSQP.vue";
import specialSituationReport from "../pages/SpecialSituationReport.vue";
import specialSituationReportCheck from "../pages/SpecialSituationReportCheck.vue";
import Test from '../pages/Test.vue';
import Letter from '../pages/Letter.vue';
import FinancialReportForm from '../pages/FinancialReportForm.vue'
import Approval from '../pages/approval.vue';
import SecondaryCommission from '../pages/SecondaryCommission.vue';
import SecondaryCommissionA from '../pages/SecondaryCommissionA.vue';
import Pricing from '../pages/Pricing.vue';
import BXLQKSM from '../pages/BXLQKSM.vue';
import NuisanceDisk from "../pages/NuisanceDisk.vue";
import VehicleApplication from '../pages/VehicleApplication.vue';
import AdvanceCommission from "../pages/AdvanceCommission.vue";
import TestLoginInfoChange from "../pages/TestLoginInfoChange.vue";
import AResourceDeletion from "../pages/AResourceDeletion.vue";
import RescindContract from '../pages/RescindContract.vue';
import DormitoryChange from '../pages/DormitoryChange.vue';
import DormitoryOccupancy from '../pages/DormitoryOccupancy.vue';
import DormitoryRental from '../pages/DormitoryRental.vue';
import OutDormitory from '../pages/OutDormitory.vue';
import ResourceBorrowing from '../pages/ResourceBorrowing.vue';
import ResourceAccess from '../pages/ResourceAccess.vue'
import ResourceBack from '../pages/ResourceBack.vue'
import RegistrationConferenceTake from '../pages/RegistrationConferenceTake.vue'
import RegistrationConferenceBack from '../pages/RegistrationConferenceBack.vue'
import DormitorySubsidy from '../pages/DormitorySubsidy.vue'
import SecondaryCommissionList from '../pages/SecondaryCommissionList.vue'
import HousingDemand from '../pages/HousingDemand.vue'
import ITSaleLargeAssets from '../pages/ITSaleLargeAssets.vue'
import MentoringRelationship from '../pages/MentoringRelationship.vue'
import RoleTransformation from '../pages/RoleTransformation.vue'
import AXSJK from '../pages/AXSJK.vue'
import IntranetIermissions from '../pages/IntranetIermissions.vue'
import clear from '../pages/clear.vue';
import SecondaryMarketAutomaticBadDebt from '../pages/SecondaryMarketAutomaticBadDebt.vue';
import ZZBDXNHSQ from '../pages/ZZBDXNHSQ.vue';
import JKQXSQ from '../pages/JKQXSQ.vue';
import HighRiskCooperation from '../pages/HighRiskCooperation.vue';
import PhotographyBorrowing from '../pages/PhotographyBorrowing.vue';
import FirstHandEarlyWarning from '../pages/FirstHandEarlyWarning.vue'
import FirstHandEarlyWarningCheck from "../pages/FirstHandEarlyWarningCheckForNew";

// import FirstHandEarlyWarning from '../pages/FirstHandEarlyWarningTemp.vue';
// import FirstHandEarlyWarningCheck from "../pages/FirstHandEarlyWarningCheckBF";

import OurDefendant from "../pages/OurDefendant";
import HousingApprentice from "../pages/HousingApprentice";
// import VirtualNumberBinding from "";ITNotAssetAllocation
// https://flow-website.centaline-sc.com/Pricing?code=SSO-4ade1876-6639-4ea7-816d-5bf6e8c6b59c

Vue.use(VueRouter);

export default new VueRouter({
	// mode:'hash',s
	mode: 'history',
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: "/",
		component: index,
		name: '/index',
		meta: {
			isLogin: true,
			title: '首页',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/specialSituationReport",
		component: specialSituationReport,
		name: '/specialSituationReport',
		meta: {
			isLogin: true,
			title: '二级市场特殊情况报备签批',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/specialSituationReportCheck",
		component: specialSituationReportCheck,
		name: '/specialSituationReportCheck',
		meta: {
			isLogin: true,
			title: '二级市场特殊情况报备签批确认',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/rentBorrowing",
		component: rentBorrowing,
		name: '/rentBorrowing',
		meta: {
			isLogin: true,
			title: '房租借支延期报销申请表',
		    keepAlive: true //true显示头部
		}
	},

	{
		path: "/firstHandProject",
		component: firstHandProject,
		name: '/firstHandProject',
		meta: {
			isLogin: true,
			title: '一手项目暂缓发函或诉讼类签批申请',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/administrativeProcurementApplication",
		component: administrativeProcurementApplication,
		name: '/administrativeProcurementApplication',
		meta: {
			isLogin: true,
			title: '行政采购申请表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/administrativeProcurementPricing",
		component: administrativeProcurementPricing,
		name: '/administrativeProcurementPricing',
		meta: {
			isLogin: true,
			title: '行政采购核价',
		    keepAlive: true //true显示头部
		}
	},{
		path: "/administrativeProcurementCheck",
		component: administrativeProcurementCheck,
		name: '/administrativeProcurementCheck',
		meta: {
			isLogin: true,
			title: '行政采购验收',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectBudget",
		component: projectBudget,
		name: '/projectBudget',
		meta: {
			isLogin: true,
			title: '工程预算申请表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectSettlement",
		component: projectSettlement,
		name: '/projectSettlement',
		meta: {
			isLogin: true,
			title: '工程结算申请表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectBudgetPricing",
		component: projectBudgetPricing,
		name: '/projectBudgetPricing',
		meta: {
			isLogin: true,
			title: '工程预算核价表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectSettlementPricing",
		component: projectSettlementPricing,
		name: '/projectSettlementPricing',
		meta: {
			isLogin: true,
			title: '工程结算核价表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectCostApplication",
		component: projectCostApplication,
		name: '/projectCostApplication',
		meta: {
			isLogin: true,
			title: '工程费用申请表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectCostPricing",
		component: projectCostPricing,
		name: '/projectCostPricing',
		meta: {
			isLogin: true,
			title: '工程费用核价申请表',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/projectCostCheck",
		component: projectCostCheck,
		name: '/projectCostCheck',
		meta: {
			isLogin: true,
			title: '工程费用申请采购验收表',
		    keepAlive: true //true显示头部
		}
	},

	{
		path: "/salaryManager",
		component: salaryManager,
		name: '/salaryManager',
		meta: {
			isLogin: true,
			title: '工资(合作费/佣金/奖金)冻结(发放)类',
		    keepAlive: true //true显示头部
		}
	},
	{
		path: "/icibe",
		component: icibe,
		name: '/icibe',
		meta: {
			isLogin: true,
			title: '员工开具收入证明'
		}
	},
	 {
		path: "/housingCircle",
		component: housingCircle,
		name: '/housingCircle',
		meta: {
			isLogin: true,
			title: '房友圈分销'
		}
	},
	{
		path: "/cooperationInfoFee",
		component: cooperationInfoFee,
		name: '/cooperationInfoFee',
		meta: {
			isLogin: true,
			title: '合作信息费申请表'
		}
	},
	{
		path: "/contractRiskWarning",
		component: contractRiskWarning,
		name: '/contractRiskWarning',
		meta: {
			isLogin: true,
			title: '合同风险预警及后置保证金签批申请'
		}
	},
	{
		path: "/specialTransaction",
		component: specialTransaction,
		name: '/specialTransaction',
		meta: {
			isLogin: true,
			title: '放款/转佣/结佣/退佣/确认收款等交易特殊情况'
		}
	},
	{
		path: "/applyFee",
		component: applyFee,
		name: '/applyFee',
		meta: {
			isLogin: true,
			title: '费用申请类签批申请表'
		}
	},
	{
		path:"/cancelEntrustedHousing",
		component:cancelEntrustedHousing,
		name:'/cancelEntrustedHousing',
		meta:{
			isLogin: true,
			title: '撤销委托房源申请表'
		}
	},
	{
		path:"/otherApplySignApprove",
		component:otherApplySignApprove,
		name:'/otherApplySignApprove',
		meta:{
			isLogin: true,
			title: '其他类签批申请表'
		}
	},

	{
		path: "/temp",
		component: temp,
		name: '/temp',
		meta: {
			isLogin: false,
			title: '测试模板'
		}
	},{
		path: "/rportapplication",
		component: rportapplication,
		name: '/rportapplication',
		meta: {
			isLogin: true,
			title: '招聘端口申请'
		}
	},{
		path: "/companyqualification",
		component: companyqualification,
		name: '/companyqualification',
		meta: {
			isLogin: true,
			title: '公司资质领取'
		},
	},{
		path: "/declarationOfInterests",
		component: declarationOfInterests,
		name: '/declarationOfInterests',
		meta: {
			isLogin: true,
			title: '利益申报表'
		},
	},{
		path: "/portFeeApplication",
		component: portFeeApplication,
		name: '/portFeeApplication',
		meta: {
			isLogin: true,
			title: '端口费用申请及盖章审批申请'
		},
	},{
		path: "/personnelRequirements",
		component: personnelRequirements,
		name: '/personnelRequirements',
		meta: {
			isLogin: true,
			title: '人员需求申请'
		},
	},{
		path: "/personnelCostApplication",
		component: personnelCostApplication,
		name: '/personnelCostApplication',
		meta: {
			isLogin: true,
			title: '人事费用申请表'
		},
	},{
		path: "/nonBusinessSeal",
		component: nonBusinessSeal,
		name: '/nonBusinessSeal',
		meta: {
			isLogin: true,
			title: '非营业部盖章申请'
		},
	},{
		path: "/overTimeApply",
		component: overTimeApply,
		name: '/overTimeApply',
		meta: {
			isLogin: true,
			title: '住宅部超过24小时或7天未完成审批报备表'
		},
	},{
		path: "/newComerAdvanced",
		component: newComerAdvanced,
		name: '/newComerAdvanced',
		meta: {
			isLogin: true,
			title: '住宅部新人进阶'
		},
	},{
		path: "/YSXMBYXWJHMTSHZSQ",
		component: YSXMBYXWJHMTSHZSQ,
		name: '/YSXMBYXWJHMTSHZSQ',
		meta: {
			isLogin: true,
			title: '一手项目必要性文件豁免特殊坏账申请'
		},
	},{
		path: "/ZBJZFSQB",
		component: ZBJZFSQB,
		name: '/ZBJZFSQB',
		meta: {
			isLogin: true,
			title: '质保金支付申请表'
		},
	},{
		path: "/KPZLHTJGPZZHTGZSQ",
		component: KPZLHTJGPZZHTGZSQ,
		name: '/KPZLHTJGPZZHTGZSQ',
		meta: {
			isLogin: true,
			title: '分行铺面租赁合同及协议盖章申请'
		},
	},
		{
			path: "/phoneShort",
			component: phoneShort,
			name: '/phoneShort',
			meta: {
				isLogin: true,
				title: '四川中原手机短号申请'
			},
		},
		{
			path: "/projectLinkage",
			component: projectLinkage,
			name: '/projectLinkage',
			meta: {
				isLogin: true,
				title: '项目联动分佣类签批申请表'
			},
		},
		{
			path: "/suspensionCommission",
			component: suspensionCommission,
			name: '/suspensionCommission',
			meta: {
				isLogin: true,
				title: '暂缓或撤销追佣委托书'
			},
		},
		{
			path: "/projectHousing",
			component: projectHousing,
			name: '/projectHousing',
			meta: {
				isLogin: true,
				title: '房友圈项目垫佣申请'
			},
		},
		{
			path: "/newBranchInvoice",
			component: newBranchInvoice,
			name: '/newBranchInvoice',
			meta: {
				isLogin: true,
				title: '分行发票新购申请单'
			},
		},
		{
			path: "/borrowing",
			component: borrowing,
			name: '/borrowing',
			meta: {
				isLogin: true,
				title: '借支申请'
			},
		},
		{
			path: "/commissionAuthorization",
			component: commissionAuthorization,
			name: '/commissionAuthorization',
			meta: {
				isLogin: true,
				title: '佣金追收授权委托书'
			},
		},{
			path: "/commissionAuthorizationSpecial",
			component: commissionAuthorizationSpecial,
			name: '/commissionAuthorizationSpecial',
			meta: {
				isLogin: true,
				title: '特殊项目是否诉讼征询'
			},
		},{
			path: "/beOnABusinessTrip",
			component: beOnABusinessTrip,
			name: '/beOnABusinessTrip',
			meta: {
				isLogin: true,
				title: '出差申请表'
			},
		},
		{
			path: "/projectCommissionRecovery",
			component: projectCommissionRecovery,
			name: '/projectCommissionRecovery',
			meta: {
				isLogin: true,
				title: '追佣项目诉讼征询'
			},
		},
		{
			path: "/projectCommissionConfirm",
			component: projectCommissionConfirm,
			name: '/projectCommissionConfirm',
			meta: {
				isLogin: true,
				title: '追佣项目联动确认申请'
			},
		},
		{
			path: "/YGRSLGZSPSQ",
			component: YGRSLGZSPSQ,
			name: '/YGRSLGZSPSQ',
			meta: {
				isLogin: true,
				title: '员工人事类盖章审批申请'
			},
		},
		{
			path: "/RSLTSSQ",
			component: RSLTSSQ,
			name: '/RSLTSSQ',
			meta: {
				isLogin: true,
				title: '人事类特殊申请'
			},
		},
		{
			path: "/TJSQB",
			component: TJSQB,
			name: '/TJSQB',
			meta: {
				isLogin: true,
				title: '团建申请表'
			},
		},
		{
			path: "/XQSQ",
			component: XQSQ,
			name: '/XQSQ',
			meta: {
				isLogin: true,
				title: '需求设计申请'
			},
		},{
			path: "/FHHCFP",
			component: FHHCFP,
			name: '/FHHCFP',
			meta: {
				isLogin: true,
				title: '分行红冲发票'
			},
		},{
			path: "/ITAssetMaintenance",
			component: ITAssetMaintenance,
			name: '/ITAssetMaintenance',
			meta: {
				isLogin: true,
				title: 'IT资产维修申请'
			},
		},
		// {
		// 	path: "/ITEquipmentAllocation",
		// 	component: ITEquipmentAllocation,
		// 	name: '/ITEquipmentAllocation',
		// 	meta: {
		// 		isLogin: true,
		// 		title: 'IT设备调拨'
		// 	},
		// },
		// {
		// 	path: "/ITEquipmentScrapping",
		// 	component: ITEquipmentScrapping,
		// 	name: '/ITEquipmentScrapping',
		// 	meta: {
		// 		isLogin: true,
		// 		title: 'IT设备报废'
		// 	},
		// },
		{
			path: "/ITNotAssetAllocation",
			component: ITNotAssetAllocation,
			name: '/ITNotAssetAllocation',
			meta: {
				isLogin: true,
				// title: '非IT资产调拨'
				title: '资产调拨'
			},
		},
		{
			path: "/iTNotAssetsScrap",
			component: iTNotAssetsScrap,
			name: '/iTNotAssetsScrap',
			meta: {
				isLogin: true,
				// title: '非IT资产设备报废',
				title: '资产报废',
				keepAlive: true 
			}
		},
		{
			path: "/ITNotSssetsSuspense",
			component: ITNotSssetsSuspense,
			name: '/ITNotSssetsSuspense',
			meta: {
				isLogin: true,
				title: '非IT资产暂存'
			},
		},{
			path: "/AdministrativeProcurementA",
			component: AdministrativeProcurementA,
			name: '/AdministrativeProcurementA',
			meta: {
				isLogin: true,
				title: '月常规分行申请'
			},
		},{
			path: "/AdministrativeProcurementB",
			component: AdministrativeProcurementB,
			name: '/AdministrativeProcurementB',
			meta: {
				isLogin: true,
				title: '月常规汇总申请'
			},
		},{
			path: "/AdministrativeProcurementInconformity",
			component: AdministrativeProcurementInconformity,
			name: '/AdministrativeProcurementInconformity',
			meta: {
				isLogin: true,
				title: '行政月常规采购申请不一致'
			},
		}
		,{
			path: "/ITAssetMaintenanceA",
			component: ITAssetMaintenanceA,
			name: '/ITAssetMaintenanceA',
			meta: {
				isLogin: true,
				title: 'IT资产维修'
			},
		},
		{
			path: "/DHYWLYWSQ",
			component: DHYWLYWSQ,
			name: '/DHYWLYWSQ',
			meta: {
				isLogin: true,
				title: '网络业务申请'
			},
		},
		{
			path: "/YKFPYQHMLQPSQ",
			component: YKFPYQHMLQPSQ,
			name: '/YKFPYQHMLQPSQ',
			meta: {
				isLogin: true,
				title: '已开发票扣款延期、豁免类签批申请'
			},
		},
		{
			path: "/GRZHQXKTHBGSQB",
			component: GRZHQXKTHBGSQB,
			name: '/GRZHQXKTHBGSQB',
			meta: {
				isLogin: true,
				title: '存量房平台账号权限申请'
			},
		},
		{
			path: "/MPSQ",
			component: MPSQ,
			name: '/MPSQ',
			meta: {
				isLogin: true,
				title: '名片申请'
			},
		},
		{
			path: "/ITSBCGSQ",
			component: ITSBCGSQ,
			name: '/ITSBCGSQ',
			meta: {
				isLogin: true,
				title: 'IT设备采购申请'
			},
		},
		{
			path: "/ITSBCGYS",
			component: ITSBCGYS,
			name: '/ITSBCGYS',
			meta: {
				isLogin: true,
				title: 'IT设备采购验收'
			},
		},
		{
			path: "/KGPSQP",
			component: KGPSQP,
			name: '/KGPSQP',
			meta: {
				isLogin: true,
				title: '开关铺申请表'
			},
		},
		{
			path: "/Test",
			component: Test,
			name: "/Test",
			meta: {
				isLogin: true,
				title: "测试"
			}
		},
		{
			path: "/Letter",
			component: Letter,
			name: "/Letter",
			meta: {
				isLogin: true,
				title: "协议及函件"
			}
		},
		{
			path: "/FinancialReportForm",
			component: FinancialReportForm,
			name:"FinancialReportForm",
			meta: {
				isLogin: true,
				title: "二级市场财务报签表"
			}
		},
		{
			path: "/Approval",
			component: Approval,
			name:"Approval",
			meta: {
				isLogin: true,
				title: "二级市场佣金分配审批"
			}
		},
		{
			path: "/SecondaryCommission",
			component: SecondaryCommission,
			name:"SecondaryCommission",
			meta: {
				isLogin: true,
				title: "二级市场佣金"
			}
		},
		{
			path: "/SecondaryCommissionA",
			component: SecondaryCommissionA,
			name:"SecondaryCommissionA",
			meta: {
				isLogin: true,
				title: "二级市场佣金A"
			}
		},
		{
			path: "/Pricing",
			component: Pricing,
			name:"Pricing",
			meta: {
				isLogin: true,
				title: "核价验收"
			}
		},
		{
			path: "/BXLQKSM",
			component: BXLQKSM,
			name:"BXLQKSM",
			meta: {
				isLogin: true,
				title: "报销类情况说明"
			}
		},
		{
			path: "/NuisanceDisk",
			component: NuisanceDisk,
			name:"NuisanceDisk",
			meta: {
				isLogin: true,
				title: "免扰盘申请",
			}
		},
		{
			path: "/VehicleApplication",
			component: VehicleApplication,
			name: "VehicleApplication",
			meta: {
				isLogin: true,
				title: "车辆申请流程"
			}
		},
		{
			path: "/AdvanceCommission",
			component: AdvanceCommission,
			name: "AdvanceCommission",
			meta: {
				isLogin: true,
				title: "垫佣资金包申请"
			}
		},
		{
			path: '/TestLoginInfoChange',
			component: TestLoginInfoChange,
			name: "TestLoginInfoChange",
			meta: {
				isLogin: true,
				title: "修改当前登陆人"
			}
		},
		{
			path: '/AResourceDeletion',
			component: AResourceDeletion,
			name: "AResourceDeletion",
			meta: {
				isLogin: true,
				title: "A+资源删除申请"
			}
		},
		{
			path: '/RescindContract',
			component: RescindContract,
			name: "RescindContract",
			meta: {
				isLogin: true,
				title: "员工宿舍租赁合同及解约协议"
			}
		},
		{
			path: "/DormitoryChange",
			component: DormitoryChange,
			name: "DormitoryChange",
			meta: {
				isLogin: true,
				title: "宿舍换宿申请表"
			}
		},
		{
			path: "/DormitoryOccupancy",
			component: DormitoryOccupancy,
			name: "DormitoryOccupancy",
			meta: {
				isLogin: true,
				title: "宿舍入住申请表"
			}
		},
		{
			path: "/DormitoryRental",
			component: DormitoryRental,
			name: "DormitoryRental",
			meta: {
				isLogin: true,
				title: "宿舍租赁申请表"
			}
		},
		{
			path: "/OutDormitory",
			component: OutDormitory,
			name: "OutDormitory",
			meta: {
				isLogin: true,
				title: "宿舍退宿申请表"
			}
		},
		{
			path: "/ResourceBorrowing",
			component: ResourceBorrowing,
			name: "ResourceBorrowing",
			meta: {
				isLogin: true,
				title: "资源借用申请"
			}
		},
		{
			path: "/PhotographyBorrowing",
			component: PhotographyBorrowing,
			name: "PhotographyBorrowing",
			meta: {
				isLogin: true,
				title: "摄影资源借用"
			}
		},
		{
			path: "/ResourceAccess",
			component: ResourceAccess,
			name: "ResourceAccess",
			meta: {
				isLogin: true,
				title: "资源借用拿取"
			}
		},
		{
			path: "/ResourceBack",
			component: ResourceBack,
			name: "ResourceBack",
			meta: {
				isLogin: true,
				title: "资源借用归还"
			}
		},
		{
			path: "/RegistrationConferenceTake",
			component: RegistrationConferenceTake,
			name: "RegistrationConferenceTake",
			meta: {
				isLogin: true,
				title: "会议室物品拿取登记"
			}
		},
		{
			path: "/RegistrationConferenceBack",
			component: RegistrationConferenceBack,
			name: "RegistrationConferenceBack",
			meta: {
				isLogin: true,
				title: "会议室物品归还"
			}
		},
		{
			path: "/DormitorySubsidy",
			component: DormitorySubsidy,
			name: "DormitorySubsidy",
			meta: {
				isLogin: true,
				title: "宿舍补贴发放申请"
			}
		},
		{
			path: "/SecondaryCommissionList",
			component: SecondaryCommissionList,
			name: "SecondaryCommissionList",
			meta: {
				isLogin: true,
				title: "二级佣金列表"
			}
		},
		{
			path: "/HousingDemand",
			component: HousingDemand,
			name: "HousingDemand",
			meta: {
				isLogin: true,
				title: "住宅部人员需求流程表"
			}
		},
		{
			path: "/ITSaleLargeAssets",
			component: ITSaleLargeAssets,
			name: "ITSaleLargeAssets",
			meta: {
				isLogin: true,
				title: "报废IT大额资产变卖流程"
			}
		},
		{
			path: "/MentoringRelationship",
			component: MentoringRelationship,
			name: "MentoringRelationship",
			meta: {
				isLogin: true,
				title: "工商铺部师徒关系"
			}
		},
		{
			path: "/RoleTransformation",
			component: RoleTransformation,
			name: "RoleTransformation",
			meta: {
				isLogin: true,
				title: "角色转换申请流程"
			}
		},
		{
			path: "/ResourceBorrowingTotal",
			component: () => import("../pages/ResourceBorrowingTotal.vue"),
			name: "ResourceBorrowingTotal",
			meta: {
				isLogin: true,
				title: "资源借用页"
			}
		},
		{
			path: "/AXSJK",
			component: AXSJK,
			name: "AXSJK",
			meta: {
				isLogin: true,
				title: "爱心社捐款"
			}
		},
		{
			path: "/IntranetIermissions",
			component: IntranetIermissions,
			name: "IntranetIermissions",
			meta: {
				isLogin: true,
				title: "公司内网访问权限申请表"
			}
		},
		{
			path:'/clear',
			component: clear,
			name: "clear",
			meta: {
				isLogin: true,
				title: "清除缓存"
			}
		},
		{
			path:'/SecondaryMarketAutomaticBadDebt',
			component: SecondaryMarketAutomaticBadDebt,
			name: "SecondaryMarketAutomaticBadDebt",
			meta: {
				isLogin: true,
				title: "二级市场其他类申请"
			}
		},
		{
			path:'/ZZBDXNHSQ',
			component: ZZBDXNHSQ,
			name: "ZZBDXNHSQ",
			meta: {
				isLogin: true,
				title: "自主绑定虚拟号申请"
			}
		},
		{
			path:'/JKQXSQ',
			component: JKQXSQ,
			name: "JKQXSQ",
			meta: {
				isLogin: true,
				title: "监控权限申请"
			}
		},
		{
			path:'/HighRiskCooperation',
			component: HighRiskCooperation,
			name: "HighRiskCooperation",
			meta: {
				isLogin: true,
				title: "高危房企合作申请"
			}
		},
		{
			path:'/FirstHandEarlyWarning',
			component: FirstHandEarlyWarning,
			name: "FirstHandEarlyWarning",
			meta: {
				isLogin: true,
				title: "一手项目达结佣阶段发函/诉讼预警表"
			}
		},
		{
			path:'/FirstHandEarlyWarningCheck',
			component: FirstHandEarlyWarningCheck,
			name: "FirstHandEarlyWarningCheck",
			meta: {
				isLogin: true,
				title: "一手项目达结佣阶段发函/诉讼预警表-营业部填写"
			}
		},
		{
			path: "/OurDefendant",
			component: OurDefendant,
			name: "OurDefendant",
			meta: {
				isLogin: true,
				title: "我司被告案件委托书"
			}
		},
		{
			path: "/HousingApprentice",
			component: HousingApprentice,
			name: "HousingApprentice",
			meta: {
				isLogin: true,
				title: "住宅部师徒关系"
			}
		},
		{
			path: '/FirstHandList',
			component: () => import("../pages/FirstHandList"),
			name: 'FirstHandList',
			meta: {
				isLogin: true,
				title: "一手达结佣代办列表"
			}
		},
		{
			path:'/Testcheck',
			component: () => import("../pages/Testcheck"),
			name: 'Testcheck',
			meta: {
				isLogin: true,
				title: "测试check"
			}
		}
	]
});
